export enum ConfigEnums {
    MaxItemsToShow = 5
}